import React from 'react';
import Book from '../book';
import styles from './rank_rec.css';

export default class RankRec extends React.Component {
    render() {
        return (
        <div className={styles.panel}>
        {this.props.data.map((item, idx) => (
            <div key={idx} className={styles.item}>
                <div className={styles.rank}>
                {idx === 0 && <div className={styles.gold}>{idx + 1}</div>}
                {idx === 1 && <div className={styles.silver}>{idx + 1}</div>}
                {idx === 2 && <div className={styles.copper}>{idx + 1}</div>}
                {idx > 2 && <div className={styles.normal}>{idx + 1}</div>}
                </div>
                <div className={styles.book}>
                    {idx === 0 && <Book template='brief_3' {...item} />}
                    {idx > 0 && <Book template='brief_4' {...item} />}
                </div>
            </div>
        ))}
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/rec/rank_rec.js